// tslint:disable: completed-docs

import { RootState } from '@vfde-fe/sails_core';
import { CONTAINER_MAIN } from 'Constant';
import { createSelector, Selector } from 'reselect';
import { selectSubscription } from '../Tariff/selectors';
import {
    IInitialState as IInitialStateDeviceDetail,
    Offer,
    OfferWithoutSubscription,
} from './interfaces/state';
import {
    HardwareDetailsResponse,
} from './interfaces/api';
import { IInitialState as IInitialStateOptions } from '../Options/interfaces/state';
import { initialState } from './reducer';

const selectState = (state: RootState<IInitialStateDeviceDetail>) => state[CONTAINER_MAIN] || initialState;

const selectLoading = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['loading']> =>
    createSelector(
        selectState,
        state => state.loading,
    );

const selectDevice = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['payload']> =>
    createSelector(
        selectState,
        state => state.payload,
    );

const selectHardwareOnly = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['isHardwareOnly']> =>
    createSelector(
        selectState,
        state => state.isHardwareOnly,
    );

const selectName = (): Selector<RootState<IInitialStateDeviceDetail>, HardwareDetailsResponse['name'] | undefined> =>
    createSelector(
        selectState,
        (state) => state.payload?.name,
    );

const selectVendor = (): Selector<RootState<IInitialStateDeviceDetail>, HardwareDetailsResponse['vendor'] | undefined> =>
    createSelector(
        selectState,
        (state) => state.payload?.vendor,
    );

const selectInsurance = (): Selector<RootState<IInitialStateDeviceDetail>, HardwareDetailsResponse['insurance'] | undefined> =>
    createSelector(
        selectState,
        (state) => state.payload?.insurance,
    );

const selectInsuranceSelected = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['insuranceSelected']> =>
    createSelector(
        selectState,
        state => state.insuranceSelected,
    );

const selectForceRerender = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['forceRerender']> =>
    createSelector(
        selectState,
        state => state.forceRerender,
    );

const selectTradeIn = (): Selector<RootState<IInitialStateDeviceDetail>, IInitialStateDeviceDetail['isTradeIn']> =>
    createSelector(
        selectState,
        state => state.isTradeIn,
    );

const selectOffer = (): Selector<RootState<IInitialStateDeviceDetail & IInitialStateOptions>, Offer | OfferWithoutSubscription | null> =>
    createSelector(
        selectState, selectSubscription(), selectInsurance(),
        (state, subscription, insurance) => {
            if (!state.payload) {
                return null;
            }

            return {
                ...(subscription || {}),
                insurance,
            };
        },
    );

export {
    selectLoading,
    selectDevice,
    selectHardwareOnly,
    selectName,
    selectVendor,
    selectInsurance,
    selectInsuranceSelected,
    selectForceRerender,
    selectTradeIn,
    selectOffer,
};
